export default "/images/847d3454a45f121d5b4e08cd2a1aa81b.avif";